module.exports = __webpack_public_path__ + "static/assets/ae4cdff7e603343d3bd43c4683b99ecd.svg";